import React from "react";
import CustomModal from "../../common/CustomModal";
import CircleAlertIcon from "../../../assets/icons/CircleAlertIcon";
import { Button } from "antd";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  closable?: boolean;
  reRender: (val: boolean) => void;

  handleConfirmUpload: () => void;
  postLoading: any;
};

export default function InvoiceConfirmModal({
  open,
  handleClose,
  data,
  reRender,

  handleConfirmUpload,
  postLoading,
  closable = false,
}: Props) {
  return (
    <>
      <CustomModal
        width={400}
        title=""
        open={open}
        handleClose={handleClose}
        closable={closable}
      >
        <div className="p-6">
          <div className="flex items-center justify-center mb-4">
            <CircleAlertIcon />
          </div>
          <div className="flex items-center justify-center text-zinc-700 text-sm font-medium">
            Are you sure to change the payment status?
          </div>

          <div className="flex justify-center mt-7 gap-3">
            <Button
              onClick={() => handleClose()}
              size="large"
              className="w-42 cancel_btn !bg-[#8897AE] !text-white !border-[2px] !border-transparent hover:!border-[#8897AE] transition-all duration-200"
            >
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              className="w-42"
              onClick={handleConfirmUpload}
              loading={postLoading}
            >
              Yes, Confirm
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
